<script>
export default {
  props: {
    loader: Boolean,
    maxWidth: String,
    closeButton: { type: Boolean, default: true },
    footer: { type: Boolean, default: true },
    header: { type: Boolean, default: true },
  },
  data() {
    return {};
  },
};
</script>

<template>
  <Transition :style="{ maxWidth: maxWidth }" name="fadeGrowingCenterFixed">
    <div style="" class="modal-content">
      <div v-if="header" class="modal-header">
        <slot name="header"></slot>
        <span
          v-if="closeButton"
          @click="$emit('close', false)"
          class="btn-close"
        ></span>
      </div>
      <div :style="{ 'padding-top': !header ? '1rem' : '0rem' }" class="modal-main">
        <slot name="body"></slot>
      </div>
      <div
        v-if="footer"
        :style="{ marginTop: $slots.footer ? '1.5rem' : '0' }"
        class="modal-footer"
      >
        <slot name="footer"></slot>
      </div>
    </div>
  </Transition>
</template>
  
<style scoped>
.primary-list {
  margin-top: 0px;
}

.btn-close {
  margin-left: auto;
}
</style>
  